import { Android, Apple, Email, Language } from '@mui/icons-material';
import {
  Grid,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import details from 'details.json';
// @ts-expect-error
import preferences from 'preferences.json';
import { NavLink as RouterLink } from 'react-router-dom';
import { DOCS_LINKS, MOBILE_APP_LINKS } from 'src/constants';
import { useDynamicBrand } from 'src/context/DynamicBrandContext';
import { useOrganisation } from 'src/hooks/useOrganisation';
import { ORGANISATION } from 'switch-shared/types/general.enums';

interface Props {
  setManualStep: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const PageOne = ({ setManualStep }: Props) => {
  /* Hooks & Use Effects */
  const theme = useTheme();
  const environment = useOrganisation();
  const { config: brandConfig, isActive } = useDynamicBrand();
  const brandFullName = brandConfig.brandName;
  const brandDetails = brandConfig.contactDetails
    ? brandConfig.contactDetails
    : { website: details?.website, email: details?.email };

  /* States */

  /* API Calls */

  /* Functions & Functional Components */

  return (
    <>
      <Grid
        container
        sx={{
          justifyContent: 'flex-start',
        }}
      >
        <Grid item container flexDirection={'column'}>
          <Typography variant='h2' component='span'>
            <Typography variant='h2' component='span'>
              Welcome to{' '}
            </Typography>
            <Typography
              variant='h2'
              component='span'
              style={{ color: theme.colors.primary.main }}
            >
              {brandFullName}.
            </Typography>
          </Typography>
          <Typography variant='h5' component='span' sx={{ mt: 1 }}>
            Your simplified smart metering platform.
            {isActive && ' Powered by '}
            {isActive && (
              <Typography
                variant='h5'
                component='a'
                href='https://www.switch.org.za'
                style={{
                  color: theme.colors.primary.main,
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                Switch Energy.
              </Typography>
            )}
          </Typography>
        </Grid>
        <Grid item container flexDirection={'column'} sx={{ mt: 5 }}>
          <Typography variant='h4' component='span'>
            Quick Links
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemButton
                href={brandDetails.website}
                component={Link}
                sx={{ px: 0 }}
              >
                <ListItemIcon>
                  <Language sx={{ color: 'black' }} />
                </ListItemIcon>
                <ListItemText primary={`${brandFullName} website`} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to={`mailto:${brandDetails.email}`}
                sx={{ px: 0 }}
              >
                <ListItemIcon>
                  <Email sx={{ color: 'black' }} />
                </ListItemIcon>
                <ListItemText primary={brandDetails.email} />
              </ListItemButton>
            </ListItem>
            {preferences.mobile_features !== false && (
              <ListItem disablePadding>
                <ListItemButton
                  href={MOBILE_APP_LINKS.IOS}
                  component={Link}
                  sx={{ px: 0 }}
                >
                  <ListItemIcon>
                    <Apple sx={{ color: 'black' }} />
                  </ListItemIcon>
                  <ListItemText primary='Switch Energy IOS App' />
                </ListItemButton>
              </ListItem>
            )}

            {preferences.mobile_features !== false && (
              <ListItem disablePadding>
                <ListItemButton
                  href={MOBILE_APP_LINKS.ANDROID}
                  component={Link}
                  sx={{ px: 0 }}
                >
                  <ListItemIcon>
                    <Android sx={{ color: 'black' }} />
                  </ListItemIcon>
                  <ListItemText primary='Switch Energy Android App' />
                </ListItemButton>
              </ListItem>
            )}
          </List>
        </Grid>

        <Grid item container flexDirection={'column'} sx={{ mt: 5 }}>
          <Typography variant='h4' component='span'>
            Help Guides
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemButton
                href={DOCS_LINKS.USERS}
                component={Link}
                sx={{ px: 0 }}
              >
                <ListItemText primary={`\u2022 User Management`} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                href={DOCS_LINKS.ACCOUNTS}
                component={Link}
                sx={{ px: 0 }}
              >
                <ListItemText primary={`\u2022 Account Management`} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                href={DOCS_LINKS.TARIFFS}
                component={Link}
                sx={{ px: 0 }}
              >
                <ListItemText primary={`\u2022 Tariff Management`} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                href={DOCS_LINKS.BILLING_RUNS}
                component={Link}
                sx={{ px: 0 }}
              >
                <ListItemText primary={`\u2022 Billing Run Management`} />
              </ListItemButton>
            </ListItem>
            {environment === ORGANISATION.EXPROP && (
              <ListItem disablePadding>
                <ListItemButton
                  href={DOCS_LINKS.PROFIT_SHARE}
                  component={Link}
                  sx={{ px: 0 }}
                >
                  <ListItemText primary={`\u2022 Profit Share Guide`} />
                </ListItemButton>
              </ListItem>
            )}
          </List>
        </Grid>
      </Grid>
    </>
  );
};

export default PageOne;
